import { ChangeDetectionStrategy, Component, forwardRef, inject, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CoverageGroupImplicit, CoverageInput } from '../../classes';
import { CoverageGroupIdEnum, CoverageGroupLayoutEnum } from '../../enums';
import { NewModal } from 'outshared-lib';
import { CoverageInputDataInputInterface } from '@app/my-zone/shared/insurance-coverage/insurance-coverage-control';
import {
    WucCardModule, WucIconUiModule, WucLinkModule,
    WucPriceModule,
    WucScribbleCircleModule,
    WucTextHighlightModule,
} from '@inshared/website-ui-components';
import { NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';

@Component({
    selector: 'ins-coverage-implicit',
    templateUrl: 'coverage-implicit.component.html',
    styleUrls: ['./coverage-implicit.component.scss'],
    providers: [{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CoverageImplicitComponent),
      multi: true,
    }],
    standalone: true,
    imports: [
        WucCardModule,
        WucPriceModule,
        WucTextHighlightModule,
        WucScribbleCircleModule,
        WucIconUiModule,
        WucLinkModule,
        NgSwitch,
        NgSwitchCase,
        NgSwitchDefault,
        NgIf
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoverageImplicitComponent implements ControlValueAccessor, OnInit {

    @Input() public group: CoverageGroupImplicit;

    public input: CoverageInput;
    public coverageGroupLayoutEnum = CoverageGroupLayoutEnum;
    public coverageGroupIdEnum = CoverageGroupIdEnum;
    public modalService: NewModal = inject(NewModal);
    public propagateChange;
    public value: { enabled: boolean } = {
        enabled: false,
    };
    public ngOnInit(): void {
        // Coverage Implicit only has one input so we take the first
        this.input = this.group.inputs[0];
    }

    public writeValue(): void {
        this.value.enabled = true;
    }

    public registerOnChange(fn: any): void {
        this.propagateChange = () => {
            fn(this.value.enabled ? this.input.id : '');
        };
    }

    public registerOnTouched(): void {
        return;
    }

    public async displayInformation(data: CoverageInputDataInputInterface): Promise<void> {
        const { CoverageControlInformationModal } = await import('../coverage-control-information/coverage-control-information.modal');
        this.modalService.open(CoverageControlInformationModal, { data });
    }
}
